export default {
      id: "ar_rando-usage",
      viewBox: "0 0 110 100",
      url: "../dist/images/" + "sprite.svg#ar_rando-usage",
      toString: function () {
        return this.url;
      }
    }